import CloseButton from '../../../components/CloseButton/CloseButton'
import { usePromo } from '../../../context/promoContext'
import useStrings from '../../../localization/useStrings'
import native from '../../../native/native'
import svg from '../../../utils/svg'
import styles from './LimitedTimePaywallTop.module.scss'

interface Props {
  containerClassName: string
}

const LimitedTimePaywallTop = (props: Props) => {
  const strings = useStrings().promo

  return (
    <div className={`${styles.container} ${props.containerClassName}`}>
      <CloseButton
        className={styles.closeButton}
        onClick={() => {
          native.postNativeEvent("close")
        }}
      />
      <div className={styles.titleContainer}>
        <svg.Bolt />
        <label className={styles.title}>{strings.oneTimeOffer}</label>
      </div>
      <Chart />
    </div>
  )
}

interface PricingContainerProps {
  title: string
  content: string
  className: string
}

const Chart = () => {
  const strings = useStrings().promo
  const pricing = usePromo().state.pricing.yearlyPriceFull.formatted

  return (
    <div className={styles.chartCenterContainer}>
      <div className={styles.chartContainer}>
        <svg.Graph style={{ width: "auto", height: "100%" }} />
        <div className={styles.itemsContainer}>
          <PricingContainer
            className={styles.leftChartItem}
            title={strings.normalFee}
            content={strings.yearlyShort(pricing)}
          />
          <PricingContainer
            className={styles.rightChartItem}
            title={strings.backTo}
            content={strings.yearlyShort(pricing)}
          />
        </div>
      </div>
    </div>
  )
}

const PricingContainer = (props: PricingContainerProps) => {
  return (
    <div className={`${styles.chartItemContainer} ${props.className}`}>
      <div className={styles.chartContentContainer}>
        <label className={styles.chartItemTitle}>{props.title}</label>
        <label className={styles.chartItemValue}>{props.content}</label>
      </div>
      <div className={styles.arrow} />
    </div>
  )
}

export default LimitedTimePaywallTop
